import { useContext } from 'react';
import t from 'react-translate';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { getProgramDatesText } from 'athena/components/program-header/program-dates';


const PageContents = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const {
    name,
    description,
    releasedDate,
    endDate,
  } = mentoringProgram || {};

  const formattedDates = releasedDate ? getProgramDatesText(releasedDate, endDate) : null;

  return (
    <div>
      <div className='bold mb-2'>
        {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.PAGE_CONTENTS()}
      </div>
      <div className='mb-4'>
        {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.PAGE_CONTENTS_DESCRIPTION()}
      </div>

      {/* Read-only program info table */}
      <div className='bg-color-gray-7 border-gray-5-1 border-radius-2 mb-4'>
        <div className={`d-flex p-3 ${(description || formattedDates) && 'border-bottom border-gray-5'}`}>
          <div className='w-25 gray-2 semi-bold'>
            {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.PROGRAM_NAME()}
          </div>
          <div className='w-75'>{name}</div>
        </div>
        {description && (
          <div className={`d-flex p-3 ${formattedDates && 'border-bottom border-gray-5'}`}>
            <div className='w-25 gray-2 semi-bold'>
              {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.PROGRAM_DESCRIPTION()}
            </div>
            <div className='w-75'>{description}</div>
          </div>
        )}
        {formattedDates && (
          <div className='d-flex p-3'>
            <div className='w-25 gray-2 semi-bold'>
              {t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.REGISTRATION_PAGE.PROGRAM_DATES()}
            </div>
            <div className='w-75'>{formattedDates}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageContents;
